(function ($) {
	'use strict';

	const $hero = $('.hero-homepage');
	const $loading = $('.hero-homepage--loading-screen');

	if ($hero.length) {
		$(document).on('ready', function() {
			hh_init();
			hh_heights();
			getIsMobile();
		});

		$(window).on({
			'scroll touchmove': function() {
				hh_scroll();
				hh_heights();
			},
			'resize': function() {
				hh_scroll();
				hh_heights();
			}
		});
	}

	function getIsMobile() {
		return $('#heroHomepageHelper').css('display') === 'none' ? true : false;
	}

	function hh_init() {
		setTimeout(function() {
			$('.hero-homepage-step.--step-1').addClass('start');
		}, 1400);

		setTimeout(function() {
			var currentScroll = $(window).scrollTop();
			var loadingScreenHeight = $('.hero-homepage--loading-screen').outerHeight();
			$('body').css('max-height', (loadingScreenHeight + 50 - currentScroll) + 'px');
		}, 2000);
	}

	function hh_heights() {
		let target;
		let isMobile = getIsMobile();
		const loadingBottom = $loading.offset().top + $loading.outerHeight();
		const predictedScrollTop = loadingBottom - $(window).height();
		let secondRound = $('body.second-round').length ? true : false;
		target = predictedScrollTop + (isMobile ? (secondRound ? 190 : 140) : (secondRound ? 370 : 220));

		$('.hero-homepage-step.--step-2 .hero-homepage-step__inner').css('padding-top', target + 'px');
	}

	function hh_scroll() {
		let isMobile = getIsMobile();
		let scrollTop = $(window).scrollTop();
		const loadingBottom = $loading.offset().top + $loading.outerHeight() + (isMobile ? 0 : 30);
		const windowBottom = scrollTop + $(window).height();

		if (loadingBottom  >= scrollTop && loadingBottom <= windowBottom) {
			$hero.addClass('loading-is-hidden');
			$('.hero-homepage-step.--step-2').addClass('start');

			setTimeout(function() {
				$('body')
					.css('max-height', '100%')
					.css('overflow', 'initial')
					.addClass('completed-once');
			}, 2000);

		} else {
			$hero.removeClass('loading-is-hidden');

			if ( !$('.completed-once').length ) {
				setTimeout(function() {
					$('body')
						.css('max-height', $loading.outerHeight() + 50 + 'px')
						.css('overflow', 'hidden');
				}, 1000);
	 		}
			else {
				$('body').addClass('second-round');
			}
		}
	}

})(jQuery);
